<template>
  <bita-modal
    id="edit-modal"
    :title="title"
    :is-loading="isLoading"
    :modal-sm="true"
    @close="reset"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <bita-select
              ref="provinceSelect"
              name="province_id"
              label="استان"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              :data-source="provinces"
              data-text-field="name"
              data-value-field="id"
              v-model="formData.province_id"
              @change="onChangeProvince()"
            />
            <bita-select
              ref="citySelect"
              name="city_id"
              label="شهر"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              :data-source="cities"
              data-text-field="name"
              data-value-field="id"
              v-model="formData.city_id"
            />
            <bita-input
              type="text"
              name="name"
              label="نام"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="formData.name"
            />
          </div>
        </div>
      </bita-form>
    </div>
    <div slot="footer">
      <bita-bootbutton
        v-if="!formData.id"
        type="primary"
        title="ذخیره"
        icon="fas fa-save"
        btn-width="150px"
        @click.native="save"
      />
      <bita-bootbutton
        v-else
        title="بروزرسانی"
        type="primary"
        icon="fas fa-save"
        btn-width="150px"
        @click.native="update"
      />
    </div>
  </bita-modal>
</template>
<script>
import { citiesApi } from "@/api/apiManagement";

export default {
  data() {
    return {
      colWidth: "col-lg-12",
      formData: {},
      isLoading: false,
      provinces: [],
      cities: [],
    };
  },
  computed: {
    title() {
      return this.formData.id ? `ویرایش ${this.formData.name}` : `افزودن`;
    },
  },
  methods: {
    init(data) {
      if (!data?.id) {
        this.formData = data;
        if (!this.provinces) return;
        this.fetchDefaults();
      } else {
        this.isLoading = true;
        console.log("oooo".data);
        Promise.all([
          citiesApi.getProvinces(),
          citiesApi.getCities(data.province_id),
        ])
          .then((res) => {
            this.provinces = res[0].data.entity;
            this.cities = res[1].data.entity;
            setTimeout(() => {
              this.formData = data;
            }, 200);
          })
          .finally(() => (this.isLoading = false));
      }

      this.$showModal("#edit-modal");
    },
    fetchDefaults() {
      this.isLoading = true;
      citiesApi
        .getProvinces()
        .then((res) => {
          this.provinces = res.data.entity;
        })
        .finally(() => (this.isLoading = false));
    },
    onChangeProvince() {
      this.isLoading = true;
      citiesApi
        .getCities(this.formData.province_id)
        .then((res) => {
          this.cities = res.data.entity;
        })
        .finally(() => (this.isLoading = false));
    },
    save() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.isLoading = true;
          citiesApi
            .createDitricts(this.formData)
            .then((res) => {
              this.$hideModal("#edit-modal");
              this.$emit("on-reload");
            })
            .finally(() => (this.isLoading = false));
        }
      });
    },
    update() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.isLoading = true;
          citiesApi
            .updateDitricts(this.formData.id,this.formData)
            .then((res) => {
              this.$hideModal("#edit-modal");
              this.$emit("on-reload");
            })
            .finally(() => (this.isLoading = false));
        }
      });
    },
    reset() {
      this.formData = {};
      this.$refs.provinceSelect.reset();
      this.$refs.citySelect.reset();
      this.$refs.form.reset();
    },
    setErrors(_errors) {
      this.$refs.form.setErrors(_errors);
    },
  },
};
</script>
